





































































































// Vue
import Vue from "vue";
// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// Models
import { CustomerModel } from "@/core/api/apiClient";
import { toTitleCase, toSentenceCase } from "@/core/utils/stringUtils";
import { debounce } from "@/core/utils/functionUtils";

const DEBOUNCE_RATE = 500;

export default Vue.extend({
  name: "CreateCustomerDialog",
  mixins: [validationMixin],

  data() {
    const self = this as any;
    return {
      dialog: false,

      name: "",
      email: "",
      phone: "",
      ext: undefined as string | undefined,
      businessAddress: "",
      notes: "",
      isCOD: false,

      // Debounced functions
      debounceCapitalizeName: debounce(self.capitalizeName, DEBOUNCE_RATE),
      debounceCapitalizeBusinessAddress: debounce(self.capitalizeBusinessAddress, DEBOUNCE_RATE),
      debounceCapitalizeNotes: debounce(self.capitalizeNotes, DEBOUNCE_RATE)
    };
  },

  validations: {
    name: { required }
  },

  methods: {
    /**
     * Submits the New Job to the server and updates the list.
     * @author Nick Brahimir
     */
    submit(): void {
      const newCustomer: CustomerModel = new CustomerModel({
        name: this.name,
        customerId: "",
        email: this.email,
        phone: this.phone,
        ext: this.ext ?? undefined,
        businessAddress: this.businessAddress,
        notes: this.notes,
        isCOD: this.isCOD,
        lastUsedTimestamp: new Date()
      });

      this.$emit("created-customer", newCustomer);
      this.close();
    },

    close(): void {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.ext = undefined;
      this.businessAddress = "";
      this.notes = "";
      this.isCOD = false;

      this.$v.$reset();
      this.dialog = false;
    },

    capitalizeName(): void {
      this.name = toTitleCase(this.name);
    },

    capitalizeBusinessAddress(): void {
      this.businessAddress = toTitleCase(this.businessAddress);
    },

    capitalizeNotes(): void {
      this.notes = toSentenceCase(this.notes);
    }
  },

  computed: {
    /**
     * Parses any Name errors.
     * @author Nick Brahimir
     */
    nameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required");
      return errors;
    }
  }
});
